/* globals RemoteHunterAuth, RemoteHunterJobs */

import { notify } from 'notify';

(function () {
	const ORIGIN = `https://jobs.sidehustles.com`;
	const JAR_KEY = `rh_widget_session`;

	function load_script(src) {
		return new Promise((resolve, reject) => {
			const script_el = document.createElement(`script`);
			script_el.src = src;
			script_el.async = true;
			script_el.addEventListener(`load`, () => resolve());
			script_el.addEventListener(`error`, () => reject(new Error(`failed to load ${src}`)));
			document.head.appendChild(script_el);
		});
	}

	function init_auth_widget() {
		if (!window.RemoteHunterAuth || !document.getElementById(`rh-auth`)) {
			return;
		}

		window.rhAuth = RemoteHunterAuth.init({
			container: `#rh-auth`,
			theme: {
				accentColor: `#FF8332`,
				accentTextColor: `#ffffff`,
			},
			onSessionChange(event) {
				if (event === `popup_blocked`) {
					notify(
						`error`,
						`Your browser blocked the Remote Hunter login popup — please allow popups for this site and try again.`,
					);
				}
			},
		});
	}

	function register_job(job) {
		if (!window.RemoteHunterJobs || !job || !job.uuid) {
			return;
		}

		RemoteHunterJobs.trackJob(job.uuid).catch(() => null);

		RemoteHunterJobs.checkJob(job.uuid).catch((err) => {
			if (!err || err.status !== 404) {
				throw err;
			}

			return RemoteHunterJobs.createJob({
				uuid: job.uuid,
				url: job.url,
				title: job.title,
				description: job.description,
				company_name: job.company_name,
			});
		});
	}

	function init_jobs_rpc() {
		// Single-job pages render a #job-data JSON blob (uuid/title/company_name/description/url).
		// The hub job-modal has no #job-data — it calls open_popup() directly with the job it
		// already has in memory, which tracks the view itself (see js/_partials/_rh-widget.js).
		const data_el = document.getElementById(`job-data`);
		if (data_el) {
			try {
				register_job(JSON.parse(data_el.textContent));
			} catch {
				// Do nothing
			}
		}
	}

	function read_jar() {
		try {
			return JSON.parse(localStorage.getItem(JAR_KEY) || `null`);
		} catch {
			return null;
		}
	}

	function write_jar(session) {
		try {
			if (session) {
				localStorage.setItem(JAR_KEY, JSON.stringify(session));
			} else {
				localStorage.removeItem(JAR_KEY);
			}
		} catch {
			// storage unavailable
		}
	}

	function overlay_win() {
		const frame_el = document.getElementById(`rh-iframe-overlay`);

		return frame_el && frame_el.contentWindow ? frame_el.contentWindow : null;
	}

	window.addEventListener(`message`, (e) => {
		if (e.origin !== ORIGIN || !e.data || !e.data.type) {
			return;
		}

		const ow = overlay_win();

		switch (e.data.type) {
			case `RH_WIDGET_SESSION_REQUEST`:
				// funnel is booting; send the shared session
				if (ow && e.source === ow) {
					ow.postMessage(
						{
							type: `RH_WIDGET_SESSION_TOKEN`,
							session: read_jar(),
						},
						ORIGIN,
					);
				}
				break;
			case `RH_WIDGET_AUTH_SUCCESS`:
				// a login landed inside the funnel; persist it
				if (ow && e.source === ow && e.data.data && e.data.data.session) {
					write_jar(e.data.data.session);
				} else if (ow && e.source === ow && e.data.session) {
					write_jar(e.data.session);
				}
				break;
			case `RH_WIDGET_SESSION_INVALID`:
				// funnel signed out + already revoked; drop our copy
				if (ow && e.source === ow) {
					write_jar(null);
				}
				break;
			case `RH_WIDGET_CLOSE`:
				// theme's own listener also handles this; harmless twice
				const frame_el = document.getElementById(`rh-iframe-overlay`);
				if (frame_el && e.source === ow) {
					frame_el.remove();
				}
				break;
		}
	});

	load_script(`${ORIGIN}/widget/auth-loader.js`).then(init_auth_widget, () => null);
	load_script(`${ORIGIN}/widget/rpc-loader.js`).then(init_jobs_rpc, () => null);
})();
